/* 🤖 this file was generated by svg-to-ts */
export const siriusSignOut: {
  name: 'sign_out';
  data: string;
} = {
  name: 'sign_out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M4.5 3A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h5.25a.75.75 0 0 0 0-1.5H4.5v-15h5.25a.75.75 0 0 0 0-1.5H4.5Z" fill="currentColor"/><path d="M15.783 7.532a.75.75 0 0 1 1.061 0l3.936 3.938a.75.75 0 0 1 0 1.06l-3.936 3.938a.75.75 0 0 1-1.06-1.06l2.656-2.658H9.75a.75.75 0 0 1 0-1.5h8.69l-2.657-2.657a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>`
};
